import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthenticationApi from "./api/authenticationApi";
import * as timexHelper from "./common/helper";
import LocalStorageHelper from "./common/localStorageHelper";
import PrivateRoute from "./components/privateRoute";
import Login from "./containers/login";
import * as config from "./data/config";
import Footer from "./components/Footer";
import StationPage from "./pages/stationPage";
import FlightsPage from "./pages/flightsPage";

class Routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            isLoading: true,
            user: null,
        };
    }

    handleStateChange(isAuthenticated, user) {
        this.setState({ isAuthenticated: isAuthenticated, user: user });
    }

    componentDidMount() {
        const user = LocalStorageHelper.getUser();
        const isAuthenticated = timexHelper.IsLoggedIn() && user;
        if (config.environment.ignoreAuthentication) {
            this.setState({ isAuthenticated: true, isLoading: false, user: null });
        } else if (isAuthenticated) {
            AuthenticationApi.validateToken(user.token)
                .then((isValid) => {
                    if (isValid) {
                        this.setState({ isAuthenticated: true, user: user });
                    } else {
                        LocalStorageHelper.removeUser();
                    }
                    this.setState({ isLoading: false });
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route
                        path="/login"
                        exact
                        render={(props) => <Login {...props} onLoginChange={this.handleStateChange.bind(this)} />}
                    />
                    {/* <PrivateRoute path="/" authed={this.state.isAuthenticated} isLoading={this.state.isLoading} component={FlightSchedule} /> */}
                    <PrivateRoute
                        path="/flights"
                        authed={this.state.isAuthenticated}
                        isLoading={this.state.isLoading}
                        component={FlightsPage}
                    />
                    <PrivateRoute
                        path="/"
                        authed={this.state.isAuthenticated}
                        isLoading={this.state.isLoading}
                        component={StationPage}
                    />
                    {/* <PrivateRoute
            path="/"
            authed={this.state.isAuthenticated}
            isLoading={this.state.isLoading}
            component={StationClass}
          /> */}
                </Switch>
                <div>{/* <User {...this.state} onLoginChange={this.handleStateChange.bind(this)} /> */}</div>
                <Footer />
            </div>
        );
    }
}

export default Routes;
